import {
  FormControl,
  FormField,
  FormItem,
  FormLabel
} from "@/components/ui/form";
import {
  cn
} from "@/lib/utils";
import {
  ChevronDown
} from "lucide-react";
import React, {
  useState
} from "react";
import {
  useFormContext
} from "react-hook-form";

export const QuantitySelect = ({
  hasCustomizationOptions,
  maybeWishList, className
}: {
    hasCustomizationOptions: boolean
    maybeWishList: React.ReactNode,
    className?:string
}) => {
  const form = useFormContext();

  const [isOpen, setIsOpen] = useState(false);

  return (<FormField
    control={form.control}
    name='quantity'
    render={({
      field 
    }) => (
      <div className={cn("lg_mt-8 lg_px-0 flex w-full flex-row justify-between pr-6 ", className)}>
        <FormItem className={cn(
          "lg_space-y-0 flex w-full items-center space-y-0",
          hasCustomizationOptions ? "hidden" : ""
        )}>
          <FormLabel className='mr-2 text-base leading-6'>QTY:</FormLabel>
          <FormControl>
            <span className='lg_flex-0 lg_grow-0 lg_w-[100px] relative w-full min-w-[60px] grow'>
              <select
                {...field as { value: string }}
                className='h-[45px] w-full appearance-none border border-solid border-[#ABA6A0] pl-2.5 pr-8'
                onFocus={() => setIsOpen(true)}
                onBlur={() => setIsOpen(false)}
              >
                {[...Array(10)].map((_, i) => (
                  <option key={i + 1} value={(i + 1).toString()}>
                    {i + 1}
                  </option>
                ))}
              </select>
              <ChevronDown
                className={`pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 transition-transform${isOpen ? "rotate-180" : ""}`}
                size={16}
              />
            </span>
          </FormControl>
        </FormItem>
        {maybeWishList}
      </div>
    )}
  />)
}
